"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASTParser = void 0;
class ASTParser {
    buildAstNode(rule) {
        switch (rule.operator) {
            case 'value does not exist':
                return {
                    left: {
                        name: rule.field,
                        type: 'property',
                    },
                    right: {
                        value: null,
                        type: 'literal',
                    },
                    type: 'eq',
                };
            case 'value exists':
                return {
                    left: {
                        name: rule.field,
                        type: 'property',
                    },
                    right: {
                        value: null,
                        type: 'literal',
                    },
                    type: 'ne',
                };
            case 'substringof':
                return {
                    type: 'functioncall',
                    func: rule.operator,
                    args: [
                        {
                            type: 'literal',
                            value: rule.value,
                        },
                        {
                            type: 'property',
                            name: rule.field,
                        },
                    ],
                };
            default:
                return {
                    left: {
                        name: rule.field,
                        type: 'property',
                    },
                    right: {
                        value: rule.value,
                        type: 'literal',
                    },
                    type: rule.operator,
                };
        }
    }
    isRuleGroup(rule) {
        return 'combinator' in rule && 'rules' in rule;
    }
    generateOdataNode(rule) {
        return this.isRuleGroup(rule)
            ? this.convertToAst(rule)
            : this.buildAstNode(rule);
    }
    traverseToEnd(tree, node) {
        if (tree.right.type === 'and' || tree.right.type === 'or') {
            this.traverseToEnd(tree.right, node);
        }
        else {
            tree.right = {
                left: tree.right,
                right: node,
                type: tree.type,
            };
        }
    }
    convertToAst(query) {
        const combinator = query.combinator;
        if (query.rules.length <= 0) {
            return null;
        }
        if (query.rules.length == 1) {
            return this.generateOdataNode(query.rules[0]);
        }
        let odataTree = {
            left: undefined,
            right: undefined,
            type: combinator,
        };
        let previousrule = undefined;
        for (let rule of query.rules) {
            const node = this.generateOdataNode(rule);
            if (node) {
                if (!odataTree.left) {
                    odataTree.left = node;
                }
                else if (!odataTree.right) {
                    odataTree.right = node;
                }
                else {
                    if (previousrule && this.isRuleGroup(previousrule)) {
                        odataTree.right = {
                            left: odataTree.right,
                            right: node,
                            type: odataTree.type,
                        };
                    }
                    else {
                        this.traverseToEnd(odataTree, node);
                    }
                }
            }
            previousrule = rule;
        }
        if (!odataTree.left)
            return null;
        if (!odataTree.right)
            return odataTree.left;
        return odataTree;
    }
}
exports.ASTParser = ASTParser;
//# sourceMappingURL=odata-parser.js.map